export default __webpack_public_path__ + "static/media/NMG_WHITE.4327153f.png";